import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const CTA = ({ onOpenOnboarding }) => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-[#2A1810]">
      <div className="max-w-6xl mx-auto px-4 sm:px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-[#F4C430]/40 bg-gradient-to-br from-[#3D2817] to-[#4a3221] p-8 sm:p-10 lg:p-16 text-center">
          <div className="absolute -top-20 -right-20 w-72 sm:w-80 h-72 sm:h-80 rounded-full bg-[#F4C430]/15 blur-3xl" />
          <div className="absolute -bottom-16 -left-16 w-64 sm:w-72 h-64 sm:h-72 rounded-full bg-[#F4C430]/10 blur-3xl" />
          <div className="relative">
            <p className="text-[#F4C430] text-[10px] sm:text-xs tracking-[0.3em] sm:tracking-[0.35em] uppercase">Your brain will thank you</p>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5EDE0] leading-tight">
              Start your first challenge in
              <br className="hidden sm:block" /> under 30 seconds
            </h2>
            <p className="mt-3 sm:mt-4 text-[#D9C9B3] text-base sm:text-lg max-w-xl mx-auto">
              Free forever, no credit card — delight for every age
            </p>
            <div className="mt-6 sm:mt-8 flex flex-wrap justify-center gap-4">
              <Button
                onClick={onOpenOnboarding}
                className="rounded-full bg-[#F4C430] hover:bg-[#FFD34E] text-[#2A1810] font-semibold h-12 sm:h-14 px-6 sm:px-8"
              >
                Start 3 Free Challenges <ArrowRight className="ml-1" size={18} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
